import { FormikProps } from "formik";
import {
  PortalAdditionalReportRequestViewModel,
  PortalAdditionalReportViewModel,
} from "../../../../generated/data-contracts";
import { SelectedReportParamBoxItem } from "./SelectedReportParamBoxItem";

interface ISelectedReportParamBoxProps {
  selectedReport: PortalAdditionalReportViewModel | undefined;
  bag: FormikProps<PortalAdditionalReportRequestViewModel>;
  onParamChange: (pKey: string, pValue: string) => void;
  isSubmitting: boolean;
  fieldValidationTexts: Record<string, string>;
}

export function SelectedReportParamBox(
  props: Readonly<ISelectedReportParamBoxProps>,
) {
  const {
    selectedReport,
    bag,
    onParamChange,
    isSubmitting,
    fieldValidationTexts,
  } = props;

  const selectedValueChange = (paramx: string, value: string) => {
    onParamChange(paramx, value);
    if (bag.values.reportParams) {
      if (typeof value !== "undefined") {
        bag.values.reportParams[paramx] = value;
      } else {
        delete bag.values.reportParams[paramx];
      }
    }
  };

  return (
    <div className="selected-report-param-box">
      {selectedReport?.parameters?.map((p) => (
        <SelectedReportParamBoxItem
          key={p.portalAdditionalReportParamId}
          parameter={p}
          onChange={selectedValueChange}
          reportParamValue={
            bag.initialValues?.reportParams &&
            bag.initialValues.reportParams[p.reportParameter]
          }
          isSubmitting={isSubmitting}
          fieldValidationTexts={fieldValidationTexts}
        />
      ))}
    </div>
  );
}
